import clsx from 'clsx';
import React from 'react';
import Loading from '../UpdateCardWidget/Loading';
import { typographyClassName } from '../atoms/typography';

type TableProps = Pick<JSX.IntrinsicElements['table'], 'className'> & {
  headers: string[];
  rows: TableRow[];
  loading?: boolean;
};

type TableRow = {
  id: string;
  cells: (string | React.ReactNode)[];
};

export const Table: React.FC<TableProps> = ({
  headers,
  rows,
  loading = false,
  className,
}) => (
  <table className={clsx('w-full table-auto border-collapse', className)}>
    <thead>
      <tr>
        {headers.map((header) => (
          <th
            key={header}
            className={clsx(
              typographyClassName,
              'border-b pb-4 text-left font-bold',
            )}
          >
            {header}
          </th>
        ))}
      </tr>
    </thead>
    {loading ? (
      <Loading />
    ) : (
      <tbody>
        {rows.map((row) => (
          <tr key={row.id} className="h-8 hover:bg-[rgba(48,197,148,0.25)]">
            {row.cells.map((cell) => (
              <td
                key={row.id + cell}
                className={clsx(typographyClassName, 'text-left')}
              >
                {cell}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    )}
  </table>
);

export default Table;
